import { render, staticRenderFns } from "./BarEdpByPartiesPrenantesExternes.vue?vue&type=template&id=eccc28d8&"
import script from "./BarEdpByPartiesPrenantesExternes.vue?vue&type=script&lang=ts&"
export * from "./BarEdpByPartiesPrenantesExternes.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports